import { render } from "./OnCallList.vue?vue&type=template&id=25fba131"
import script from "./OnCallList.vue?vue&type=script&lang=js"
export * from "./OnCallList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__